import GatewayAxiosClient from '../GatewayAxiosClient';
import type { LedgerEntry } from './types';

export class LedgerService {
  public async fetchLedger(asOfDateTime?: string): Promise<LedgerEntry[]> {
    const res = await GatewayAxiosClient.get('/partner-management-proxy/api/v1/partners/ledger', {
      params: {
        asOfDateTime,
      },
    });
    return res.data;
  }
  public async fetchLedgerByAsset(assetType: string, assetId: string, asOfDateTime?: string): Promise<LedgerEntry[]> {
    const res = await GatewayAxiosClient.get(
      `/partner-management-proxy/api/v1/partners/ledger/${assetType}/${assetId}`,
      {
        params: {
          asOfDateTime,
        },
      },
    );
    return res.data;
  }

  public async fetchGenericAssets(assetType: string): Promise<[]> {
    const res = await GatewayAxiosClient.get(`/partner-management-proxy/api/v1/partners/${assetType}`);
    return res.data;
  }

  public async fetchGenericAssetsV2(assetType: string): Promise<[]> {
    const res = await GatewayAxiosClient.get(`/partner-management-proxy/api/v2/partners/${assetType}`);
    return res.data;
  }
}
